module.exports = __webpack_public_path__ + "static/media/photo-4.53805348.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/alabama-rural-studio/photo-4.jpg
// module id = 152
// module chunks = 0